import React, { useEffect, useState } from 'react';
import {
  GET_AI_RESOLVED_SUMMARY,
  GET_AI_UNRESOLVED_SUMMARY,
  MLClient
} from '@nile/graphql';
import SummaryCard from './SummaryCard';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';
import { useActivityTracker } from '@nile/components';
import { useSimilarTicketsStore } from '@nile/components/src/Components/AI/store/similarTicketsStore.tsx';

const HEADER_MAP = [
  { id: 'all', value: 'all', label: 'common.all' },
  {
    id: 'resolved',
    value: 'resolved',
    label: 'ticket.details.statuses.resolved',
    mixpanelEvent: 'Clicked on resolved similar tickets'
  },
  {
    id: 'unresolved',
    value: 'unresolved',
    label: 'common.unresolved',
    mixpanelEvent: 'Clicked on unresolved similar tickets'
  }
];

const AISimilarTicketsHeader = ({
  selectedHeader,
  onHeaderChange,
  data,
  currentTicketId,
  setIsMonicaLoading,
  isMonicaLoading = false,
  allSimilarTicketsData = []
}) => {
  const summaryData = useSimilarTicketsStore((state) => state.summaryData);
  const setSummaryData = useSimilarTicketsStore(
    (state) => state.setSummaryData
  );

  const API_MAP = {
    unresolved: {
      query: GET_AI_UNRESOLVED_SUMMARY,
      accessorKey: 'getAIUnresolvedSummary'
    },
    resolved: {
      query: GET_AI_RESOLVED_SUMMARY,
      accessorKey: 'getAIResolvedSummary'
    }
  };

  function getAPIMeta(status) {
    const resolvedTicketIds = [];
    const unresolvedTicketIds = [];

    allSimilarTicketsData.forEach((ticket) => {
      if (ticket.resolved) {
        resolvedTicketIds.push(ticket.ticketId);
      } else {
        unresolvedTicketIds.push(ticket.ticketId);
      }
    });

    if (status === 'resolved') {
      return {
        skip: resolvedTicketIds.length === 0,
        variables: {
          resolvedTicketIds,
          ticketId: currentTicketId
        }
      };
    }
    return {
      skip: unresolvedTicketIds.length === 0,
      variables: {
        unresolvedTicketIds,
        ticketId: currentTicketId
      }
    };
  }

  const changeHeading = async (type) => {
    onHeaderChange(type);

    const { variables, skip } = getAPIMeta(type);
    const apiData = API_MAP?.[type];

    if (apiData && currentTicketId && !skip) {
      setIsMonicaLoading(true);
      const query = apiData?.query;
      const accessorKey = apiData?.accessorKey;
      const response = await MLClient.query({
        query: query,
        variables: variables,
        fetchPolicy: 'no-cache'
      });

      const summary = response?.data?.[accessorKey] || null;

      setSummaryData(summary);
    } else {
      setSummaryData(null);
    }
    setIsMonicaLoading(false);
  };

  return (
    <>
      <div className="flex g10 mt-10 mb-10" id="similar-ticket-header">
        {HEADER_MAP.map((header, index) => {
          const headerValue = header?.value;
          const mixpanelEventOnTabChange = header?.mixpanelEvent;
          const summaryTypeClass = [
            'ai-summary-type p5 pl10 pr10 br20 pointer white-color fs10 uppercase',
            headerValue === selectedHeader && 'active'
            // isMonicaLoading && 'pointer-events-none'
          ]
            .filter(Boolean)
            .join(' ');
          return (
            <div
              className={summaryTypeClass}
              onClick={() => {
                changeHeading(headerValue);
                if (mixpanelEventOnTabChange) {
                  useActivityTracker({
                    event: mixpanelEventOnTabChange
                  });
                }
              }}
              role="tab"
              tabIndex={index}
              onKeyDown={(e) => {}}
            >
              <FormattedMessage id={header?.label} />
            </div>
          );
        })}
      </div>

      {(summaryData?.summary || summaryData) && (
        <div className="mb10" id="summaryData">
          <SummaryCard
            summary={summaryData?.summary || summaryData}
            groupSummaries={summaryData?.groupSummaries}
          />
        </div>
      )}
    </>
  );
};

export default AISimilarTicketsHeader;
